export default "varying vec2 vUv;\n\nvoid main(){\n    vUv = uv;\n    gl_Position = projectionMatrix * viewMatrix * modelMatrix * vec4(position, 1.0);\n}";